// @flow
import React, { useState, useEffect } from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import ListItemText from '@material-ui/core/ListItemText';
import InputAdornment from '@material-ui/core/InputAdornment';
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(theme => ({
    input: {
        '& .MuiFilledInput-input': {
            paddingTop: 15,
            paddingBottom: 14
        },
        '& .MuiInputAdornment-positionEnd': {
            marginBottom: -2
        }
    },
    form: {
        display: 'block',
        flexGrow: 1
    }
}));

type Props = $ReadOnly<{
    value: string | number,
    form?: boolean,
    canAdd?: boolean,
    editable?: boolean,
    parseLabel?: (value: any) => Node,
    append?: Node,

    onChange?: (value: string | number) => void,
    onSubmit?: (value: string | number) => void
}>;

function DefaultItemComponent({ value, form, canAdd, editable, inputComponent, parseLabel, append, onChange, onSubmit }: Props) {
    const classes = useStyles();

    const [innerValue, setInnerValue] = useState(value);
    const isNew = typeof value === 'undefined';

    useEffect(() => setInnerValue(value), [value]);

    const handleChange = (e) => {
        setInnerValue(e.target.value);

        if(onChange) {
            onChange(e);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if(onSubmit) {
            onSubmit(innerValue);

            if(isNew) {
                setInnerValue(undefined);
            }
        }
    };

    if(editable) {
        return (
            <form className={classes.form} onSubmit={handleSubmit}>
                <TextField
                    className={classes.input}
                    variant="filled"
                    value={typeof innerValue !== 'undefined' ? innerValue : ''}
                    onChange={handleChange}
                    InputProps={{
                        inputComponent: inputComponent,
                        endAdornment: <React.Fragment>
                            {append && <InputAdornment position="end">{append}</InputAdornment>}
                            {form ? (
                                <InputAdornment position="end">
                                    <Button type="submit" disabled={isNew && !canAdd}>
                                        {isNew ?
                                            <FormattedMessage
                                                id="config.array.itemForm.addButton"
                                                defaultMessage="Add"
                                            />
                                            :
                                            <FormattedMessage
                                                id="config.array.itemForm.saveButton"
                                                defaultMessage="Save"
                                            />
                                        }
                                    </Button>
                                </InputAdornment>
                            ) : null}
                        </React.Fragment>
                    }}
                />
            </form>
        );
    }

    return (
        <ListItemText
            primary={parseLabel? parseLabel(value) : value}
        />
    );
}

export default DefaultItemComponent;